/**
 * Community API
 * Community domain API via HTTP transport to the backend `/api` RPC.
 */

import { CommunityEvent } from '@repo/shared-types/community';
import { apiTransport as router } from './transport';
import { getContext } from './core';

export const communityApi = {
    events: {
        list: async () => {
            return router.get<CommunityEvent[]>('/community/events');
        },
        get: async (id: string) => {
            return router.get<CommunityEvent>(`/community/events/${id}`);
        },
        create: async (event: Omit<CommunityEvent, 'id' | 'attendees' | 'status'>) => {
            const context = getContext();
            return router.post<CommunityEvent>('/community/events', event, context);
        },
        update: async (id: string, updates: Partial<CommunityEvent>) => {
            const context = getContext();
            return router.patch<CommunityEvent>(`/community/events/${id}`, updates, context);
        },
        delete: async (id: string) => {
            const context = getContext();
            return router.delete<{ success: boolean }>(`/community/events/${id}`, context);
        },
        rsvp: async (id: string) => {
            const context = getContext();
            return router.post<CommunityEvent>(`/community/events/${id}/rsvp`, {}, context);
        }
    }
};

